<div class="container-fluid m-0 p-0">
  <div class="blog-header-container">
    <h1 translate>ბლოგი</h1>
  </div>
</div>

<ng-container *ngIf="i18nService.language !== 'EN'">
  <div class="container blog-item custom">
    <h1>
      თიბისი ლიზინგი - შენი საუკეთესო სამომხმარებლო გამოცდილებისთვის
    </h1>
    <h6>აპრილი 2023</h6>
    <br />

    <p>
      გიფიქრია რატომ ირჩევ კონკრეტულ პროდუქტს ან ბრენდს სამეგობროდ? რა შეგრძნებებს აღძრავს შენში? პრაქტიკულობის თუ
      ეფექტურობის გარდა, რას ელი მისგან? დაგვეთანხმები, რომ გუმანით გრძნობ, როცა კომპანია, რომელთანაც შეხება გაქვს -
      გულწრფელად ზრუნავს შენზე. ამასთანავე, თანამედროვე ორგანიზაციებსაც გააზრებული აქვთ, რომ თუ მომხმარებლის
      გამოცდილების გაუმჯობესებას საკუთარი კორპორაციული კულტურის ამომავალ წერტილად აქცევენ - იდეალური ურთიერთობა შედგება,
      მეტიც, Qualtrics XM Institute-ის კვლევის თანახმად, ასეთი კომპანიების 89% საუკეთესო ფინანსურ შედეგებს დებს.
    </p>

    <p>
      თიბისი ლიზინგში წლების წინ დავფიქრდით, როგორ შეიძლება სიტყვა - საქმედ ვაქციოთ და საოპერაციო პროცესების
      განვითარებისას სწორება თქვენი გამოცდილების გაუმჯობესებაზე გვქონდეს. სწორედ ამიტომ, ადამიანებზე ზრუნვის
      დეპარტამენტი ჩამოვაყალიბეთ და როგორც მომხმარებლების, ასევე დასაქმებულების ინტერესებზე ზრუნვა დავაპრიორიტეტეთ.
      ურთიერთობები ორმხრივია და მუდმივ ყურადღებას საჭიროებს, შესაბამისად, კმაყოფილების არა თეორიული, არამედ გაზომვადი
      განსაზღვრებები ჩამოვაყალიბეთ და მიზნად „ადამიანების პულსზე ხელის ჭერა“ დავისახეთ. მოკლედ, ყოველდღიური, თვიური თუ
      წლიური კვლევებით, უკუკავშირების მიღებითა და გადააზრებით საერთოდ ახალი, მომხმარებელზე ორიენტირებული კომუნიკაცია
      ჩამოვაყალიბეთ, რომლის მცირე ნაწილსაც ამ კამპანიის ფარგლებში გაგაცნობთ.
    </p>

    <img src="../../../../assets/blog/user-experience/img1.jpg" alt="" />
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-dark-blue">
      <div class="container">
        <p class="quote">
          “ბრენდი დაპირებაა, რომელსაც მომხმარებელს ვაძლევთ და შესაბამისად არასდროს უნდა ვუღალატოთ. რა თქმა უნდა,
          ყოველდღიურობაში აღნიშნული არც ისე მარტივია, თუმცა მიზანი როგორც მინიმუმ - მცდელობა უნდა იყოს. ჩვენს გუნდს
          სჯერა, რომ უმნიშვნელოვანესია გვესმოდეს მომხმარებლის ხმა, ვესაუბრებოდეთ მათ, ემპათია გამოვხატოთ მაშინ, როდესაც
          ვერაფერს ვცვლით და შევცვალოთ მაშინ, როდესაც შეგვიძლია. მუდმივობა არაჩვეულებრივი სიტყვაა და ნებისმიერ პროცესს
          უნდა ახასიათებდეს, ამიტომ ამ სამი წლის მანძილზე ზუსტად ეს თვისება გამოვიმუშავეთ“.
        </p>
        <p class="quote" style="font-feature-settings: 'case' on; margin-top: 42px;">
          თეო ლეჟავა
        </p>
        <p class="quote" style="font-family: 'TBCX-LIGHT'; font-size: 20px;">
          ბრენდის და ადამიანებზე ზრუნვის დეპარტამენტის უფროსი.
        </p>
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p>
      ჩვენი გუნდი თქვენს უკუკავშირს ნებისმიერ პლატფორმაზე აგროვებს, ეცნობა და ყოველკვირეულ შეკრებაზე უზიარებს იმ
      დაკავშირებულ მხარეებს, რომელთა კომპეტენციასაც აღნიშნული საკითხის დახვეწა თუ მოგვარება წარმოადგენს.
      <b class="dark-blue">
        „შესაძლოა ერთი შეხედვით მარტივმა კომენტარმა რადიკალურად სხვა თვალით დაგვანახოს მიმდინარე პროცესი და მოგვცეს
        გაუმჯობესებისთვის საჭირო მინიშნება“</b
      >. არანაკლებ ფასეულია უკვე არსებული მომხმარებლების მიერ საკუთარ მენეჯერებსა თუ ოპერატორებთან გაზიარებული
      შეხედულებები, რომელთა მიხედვითაც საოპერაციო ნაწილშიც კი შეგვიტანია ცვლილებები.
      <b class="dark-blue">
        „ვაფასებთ იმ ჩართულობას, რომელიც მუდმივი კვლევის პროცესში გვაქვს, ამიტომ უკუკავშირის მიღების შემდგომ გონივრულ
        ვადაში ვუბრუნდებით ადამიანებს და ვატყობინებთ, შევძელით თუ არა მათი მოსაზრების მიხედვით ცვლილების შეტანა“ </b
      >.
    </p>
  </div>

  <div class="carousel">
    <app-custom-carousel [images]="images" [customOptions]="customOptions"></app-custom-carousel>
  </div>

  <div class="container blog-item custom">
    <p>
      მომხმარებელთა კმაყოფილების საუკეთესო მაჩვენებელი შესაძლოა ისევ და ისევ მათ მიერ ჩვენი კომპანიის არჩევა იყოს, თუმცა
      ჩვენთვის ეს საკმარისი არ არის და უშუალო გამოკითხვით ვცდილობთ გავიგოთ, თუ როგორია მათი გამოცდილება ჩვენი პროდუქტით
      სარგებლობის ნებისმიერ ეტაპზე. სიტყვა ძალიან რომ არ გაგვიგრძელდეს, ეტაპობრივად გაგაცნობთ თხოვნებს რომელიც
      გავითვალისწინეთ და უკუკავშირს, რომელიც თქვენგან მივიღეთ.
    </p>
  </div>
</ng-container>

<ng-container *ngIf="i18nService.language === 'EN'">
  <div class="container blog-item custom">
    <h1>
      TBC Leasing - For Your Best Customer Experience
    </h1>
    <h6>April 2023</h6>
    <br />

    <p>
      Have you ever thought about why you choose a particular product or brand for your needs? What feelings does it
      evoke in you? Beyond practicality or effectiveness, what do you expect from it? You’d agree that you can feel when
      a company you interact with genuinely cares about you. Furthermore, modern organizations are aware that if they
      make improving customer experience the cornerstone of their corporate culture, an ideal relationship is formed.
      According to a study by Qualtrics XM Institute, 89% of such companies achieve the best financial results.
    </p>

    <p>
      Years ago, at TBC Leasing, we thought about how to turn the word "care" into action and, during the development of
      operational processes, we focused on improving your experience. That is why we established a department dedicated
      to caring for people, prioritizing the interests of both our customers and employees. Relationships are mutual and
      require constant attention. Therefore, we formulated measurable definitions of satisfaction, aiming to "keep our
      finger on the pulse of people." In short, through daily, monthly, and annual surveys, receiving feedback, and
      reflecting on it, we created a completely new, customer-oriented communication, a small part of which we’ll share
      with you in this campaign.
    </p>

    <img src="../../../../assets/blog/user-experience/img1.jpg" alt="" />
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-dark-blue">
      <div class="container">
        <p class="quote">
          “Brand is a promise we make to the customer, and therefore, we must never betray it. Of course, it’s not
          always easy in daily life, but the goal should be, at the very least, an attempt. Our team believes that it’s
          crucial to understand the voice of the customer, to communicate with them, show empathy when we can’t change
          anything, and to make changes when we can. Consistency is an extraordinary word, and it should characterize
          any process, which is why over these three years, we have developed exactly this quality“.
        </p>
        <p class="quote" style="font-feature-settings: 'case' on; margin-top: 42px;">
          Theo Lejava
        </p>
        <p class="quote" style="font-family: 'TBCX-LIGHT'; font-size: 20px;">
          Head of Brand and People Care Department
        </p>
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p>
      Our team collects your feedback across all platforms, reviews it, and shares it during weekly meetings with the
      relevant parties whose expertise can refine or resolve the matter at hand.
      <b class="dark-blue">
        „A seemingly simple comment may radically show us the current process from a different perspective and give us a
        hint on how to improve.“ </b
      >. Equally valuable are the opinions shared by existing customers with their managers or operators, based on which
      we have even introduced changes in the operational part.
      <b class="dark-blue">
        „We value the involvement we have in the ongoing research process, which is why, after receiving feedback, we
        get back to people within a reasonable timeframe and inform them whether we were able to implement the changes
        based on their suggestions.“ </b
      >.
    </p>
  </div>

  <div class="carousel">
    <app-custom-carousel [images]="images" [customOptions]="customOptions"></app-custom-carousel>
  </div>

  <div class="container blog-item custom">
    <p>
      The best indicator of customer satisfaction might still be their choice of our company, but for us, this is not
      enough, and we try to understand their experience at every stage of using our product through direct surveys. To
      avoid making this too long, I will gradually introduce the requests we considered and the feedback we received
      from you.
    </p>
  </div>
</ng-container>
